export class InstagramAspectRatio {
  public static readonly MinAspectRatio = 0.8;
  public static readonly MaxAspectRatio = 1.91;
}
